import React, { Component } from "react";
import { connect } from "react-redux";
import { PageHeader, Tooltip, Tag, Select, Spin, message } from "antd";
import { EditOutlined, ToolOutlined, QrcodeOutlined, MobileOutlined } from "@ant-design/icons";
import { ButtonItem, SegmentedItem, TableItemDinamico, SelectItem } from "../../../../Components/Items";
import SelectClientesItem from "../../../../Components/SelectClientesItem";
import FiltroIngenieroCMMS, { esperarFiltroDefault } from "../componentes/FiltroIngenieroCMMS";
import { cmmsPost, PRIORIDADES, prioridad, estatusTicket, formatoFechaHora } from "../cmmsComun";
import ModalTicket from "./ModalTicket";

const { Option } = Select;

// Tickets CMMS (solicitudes y reportes de falla, del ERP o del QR del equipo).
class Tickets extends Component {
    state = { loading: false, tickets: [], totalRecords: 0, valor: 1, prioridad: null, clienteId: null, empleadoAsignadoId: null, modal: false, ticketId: null, listo: false };

    componentDidMount() {
        // Arranca con el ingeniero que fijó el usuario (si fijó uno).
        esperarFiltroDefault(this, "empleadoAsignadoId").then(() => this.setState({ listo: true }));
    }

    consultar = async (params) => {
        this.setState({ loading: true });
        try {
            // Los filtros de la cabecera siempre van (la tabla, al montarse, solo conoce los suyos).
            const { prioridad, clienteId, empleadoAsignadoId } = this.state;
            const res = await cmmsPost(this.props, "selectTicketsCMMS", { ...params, prioridad, clienteId, empleadoAsignadoId });
            if (res.data.success === 2) this.setState({ tickets: res.data.data, totalRecords: res.data.totalRecords });
            else this.setState({ tickets: [], totalRecords: 0 });
        } catch (error) {
            console.log(error);
            message.error("Error al consultar los tickets");
        } finally {
            this.setState({ loading: false });
        }
    };

    aplicarFiltros = (cambios) =>
        this.setState(cambios, () =>
            this.tableRef?.updateExternalFilters({
                ...(this.tableRef.state?.externalFilters || {}),
                valor: this.state.valor,
                prioridad: this.state.prioridad,
                clienteId: this.state.clienteId,
                empleadoAsignadoId: this.state.empleadoAsignadoId,
            })
        );

    render() {
        const columns = [
            { title: "Folio", dataIndex: "codigo", key: "codigo", buscar: "codigo", sorter: true, width: 110 },
            {
                title: "Prioridad",
                dataIndex: "prioridad",
                key: "prioridad",
                sorter: true,
                width: 170,
                render: (v) => <Tag color={prioridad(v).color}>{prioridad(v).label}</Tag>,
            },
            { title: "Fecha", dataIndex: "fechaSolicitud", key: "fechaSolicitud", sorter: true, width: 150, render: (v) => formatoFechaHora(v) },
            {
                title: "Equipo",
                dataIndex: "activoTexto",
                key: "activoTexto",
                buscar: "activoTexto",
                width: 240,
                render: (v, r) => (r.activoId ? v : <Tag>Sin equipo</Tag>),
            },
            { title: "Cliente", dataIndex: "clienteNombre", key: "clienteNombre", buscar: "clienteNombre", width: 200 },
            { title: "Tipo", dataIndex: "tipoSolicitud", key: "tipoSolicitud", width: 130 },
            { title: "Solicitud", dataIndex: "solicitud", key: "solicitud", buscar: "solicitud", width: 260 },
            { title: "Solicitante", dataIndex: "solicitante", key: "solicitante", buscar: "solicitante", width: 160, render: (v, r) => [
                v,
                r.origen === 4 ? <Tooltip key="qr" title="Reportado desde el QR"><QrcodeOutlined style={{ marginLeft: 4, color: "#e8572a" }} /></Tooltip> : null,
                r.origen === 5 ? <Tooltip key="app" title="Capturado en la app"><MobileOutlined style={{ marginLeft: 4, color: "#2fb8d6" }} /></Tooltip> : null,
            ] },
            { title: "Ingeniero", dataIndex: "empleadoNombre", key: "empleadoNombre", width: 170 },
            { title: "Estatus", dataIndex: "estatus", key: "estatus", sorter: true, width: 190, render: (v) => <Tag color={estatusTicket(v).color}>{estatusTicket(v).label}</Tag> },
            {
                title: "Acción",
                dataIndex: "accion",
                key: "accion",
                fixed: "right",
                align: "center",
                width: 100,
                onCell: () => ({ className: "acciones-sin-hover", style: { textAlign: "center", padding: "4px" } }),
                render: (value) => (
                    <div className="acciones-container">
                        <Tooltip title="Abrir">
                            <ButtonItem type="default" size="small" cyan icon={<EditOutlined />} onClick={() => this.setState({ modal: true, ticketId: value._id })} />
                        </Tooltip>
                        {value.estatus !== 0 && value.estatus < 5 && (
                            <Tooltip title="Crear servicio">
                                <ButtonItem type="default" size="small" blanco icon={<ToolOutlined />} onClick={() => this.props.history.push("/panel/cmmsServicio", { ticketId: value._id })} />
                            </Tooltip>
                        )}
                    </div>
                ),
            },
        ];

        return (
            <>
                <PageHeader
                    title="Tickets"
                    subTitle="Solicitudes y reportes de falla"
                    style={{ border: "1px solid rgb(235, 237, 240)", backgroundColor: "white", marginBottom: 10 }}
                    extra={
                        <>
                            <SegmentedItem
                                options={[
                                    { label: "Abiertos", value: 1 },
                                    { label: "Terminados", value: 2 },
                                    { label: "Cancelados", value: 3 },
                                    { label: "Todos", value: 4 },
                                ]}
                                value={this.state.valor}
                                onChange={(valor) => this.aplicarFiltros({ valor })}
                            />
                            <ButtonItem type="primary" olivo className="botonAgregar" onClick={() => this.setState({ modal: true, ticketId: null })}>
                                Nuevo Ticket
                            </ButtonItem>
                        </>
                    }
                />
                <div style={{ display: "flex", flexWrap: "wrap", gap: 10, alignItems: "center", background: "white", padding: "8px 12px", marginBottom: 10, border: "1px solid rgb(235, 237, 240)" }}>
                    <SelectItem placeholder="Todas las prioridades" allowClear width={200} value={this.state.prioridad || undefined} onChange={(p) => this.aplicarFiltros({ prioridad: p || null })}>
                        {PRIORIDADES.map((p) => (
                            <Option key={p.value} value={p.value}>
                                {p.label}
                            </Option>
                        ))}
                    </SelectItem>
                    <div style={{ width: 260 }}>
                        <SelectClientesItem
                            empresaId={this.props.empresaId}
                            headersToken={this.props.headersToken}
                            placeholder="Todos los clientes"
                            allowClear
                            width="100%"
                            value={this.state.clienteId || undefined}
                            onChange={(clienteId) => this.aplicarFiltros({ clienteId: clienteId || null })}
                        />
                    </div>
                    <FiltroIngenieroCMMS {...this.props} width={290} value={this.state.empleadoAsignadoId} onChange={(empleadoAsignadoId) => this.aplicarFiltros({ empleadoAsignadoId })} />
                </div>
                {!this.state.listo ? (
                    <Spin spinning style={{ display: "block", padding: 40 }} />
                ) : (
                    <TableItemDinamico
                        onRef={(ref) => (this.tableRef = ref)}
                        totalRecords={this.state.totalRecords}
                        anadirValorFiltro={this.state.valor}
                        valorDefault={1}
                        setValor={(valor) => this.setState({ valor })}
                        setTextoFiltro={() => {}}
                        onFetchData={this.consultar}
                        loading={this.state.loading}
                        size="small"
                        dataSource={this.state.tickets}
                        columns={columns}
                        pagination={false}
                        rowKey="_id"
                        filterStorageKey={"TicketsCMMSFiltrosTabla" + this.props.empresaId}
                        onRow={(r) => ({ onDoubleClick: () => this.setState({ modal: true, ticketId: r._id }) })}
                    />
                )}
                <ModalTicket
                    visible={this.state.modal}
                    ticketId={this.state.ticketId}
                    onClose={(cambio) => this.setState({ modal: false }, () => cambio && this.tableRef?.fetchData())}
                />
            </>
        );
    }
}

const mapStateToProps = (state) => ({
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
});

export default connect(mapStateToProps)(Tickets);
